// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MinusCircleFilledSvg from "@fishx/icons-svg/es/asn/MinusCircleFilled";
import FishxIcon from '../components/FishxIcon';

var MinusCircleFilled = function MinusCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MinusCircleFilledSvg
  }));
};

MinusCircleFilled.displayName = 'MinusCircleFilled';
export default React.forwardRef(MinusCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MinusCircleFilled.js
// module id = 3131
// module chunks = 0